import { BeketDifficultRoute } from 'entities/beket/models/find-ticket/model.ts'
import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

export const getFocusDate = (
  directions: DifficultRoute[] | BeketDifficultRoute[],
  isDifficult: boolean,
) => {
  if (isDifficult) {
    const lastDirections = directions
      ?.filter((direction) => direction.date)
      ?.at(-1)

    return lastDirections?.date
  } else {
    const firstDateDirection = directions[0]

    return firstDateDirection?.back_date || firstDateDirection?.date
  }
}
